import Link from 'components/Globals/Base/Link';
import type { MenuItemProps } from 'interfaces/navigation/Header';
import type { EventData } from 'services/Gtm/entities';
import * as S from './SubmenuStyles';

interface SubMenuItemProps extends MenuItemProps {
  level: number;
  parentLabel: string;
  trackingData: EventData;
  onItemClick?: any;
}

const SubMenuItem = ({ label, url, subMenu, level, parentLabel, trackingData, onItemClick }: SubMenuItemProps) => (
  <>
    <S.MenuItemSubLi>
      <Link
        href={url || undefined}
        ariaLabel={`Go to ${label}`}
        trackingData={{
          ...trackingData,
          eventAction: `${trackingData.eventAction} - level ${level}`,
          eventLabel: `${parentLabel} > ${label}`,
        }}
        className='submenu-link'
        onMouseUp={onItemClick}
      >
        {label}
      </Link>
    </S.MenuItemSubLi>
  </>
);

export default SubMenuItem;
